import styled from 'styled-components';
import { Translate } from 'react-redux-i18n';

import { StyleColor } from '../../../../utils/styles-constants';
import { hexToRgba } from '../../../../utils/style';
import { StyledButtonRemove } from '../ButtonRemove/styles';

interface InputWrapperProps {
	hasButtonAdd: boolean;
	hasButtonRemove: boolean;
	isError?: boolean;
	hasLabel?: boolean;
}

interface IconLinkProps {
	isYoutubeIcon: boolean;
}

interface ButtonProps {
	disabled: boolean;
}

const Label = styled(Translate)`
	display: block;
	margin-bottom: 10px;
	font-family: HelveticaNeue, sans-serif;
	font-size: 16px;
	line-height: 20px;
	color: ${StyleColor.Black};
`;

const InputWrapper = styled('div')`
	position: relative;
	margin: ${(props: InputWrapperProps) => props.hasLabel ? '5px' : '25px'} 0 20px 0;
	border-radius: 6px;
	background-color: ${StyleColor.White};

	input {
		box-sizing: border-box;
		width: 100%;
		height: 40px;
		padding: 10px 70px 10px 50px;
		padding-right: ${(props: InputWrapperProps) => {
			if (props.hasButtonAdd && props.hasButtonRemove) {
				return '70px';
			} else if (props.hasButtonRemove) {
				return '40px';
			}
			return '10px';
		}};
		border: 1px solid ${(props: InputWrapperProps) => props.isError
			? `${StyleColor.Red}`
			: `${StyleColor.White}`};
		outline: 0;
		border-radius: 6px;
		font-family: HelveticaNeue, sans-serif;
		font-size: 14px;
		line-height: 18px;
		color: ${hexToRgba(StyleColor.Black, 50)};
		-webkit-appearance: none;

		&:disabled {
			background-color: ${StyleColor.White};
		}

		&:hover,
		&:focus {
			border: 1px solid ${(props: InputWrapperProps) => props.isError
				? `${StyleColor.Red}`
				: `${StyleColor.Blue300}`};
		}

		&::placeholder {
			color: ${hexToRgba(StyleColor.Black, 40)};
		};

		&::-ms-clear {
			display: none;
		}
	}

	${StyledButtonRemove} {
		position: absolute;
		top: 9px;
		right: 9px;
	}
`;

const IconLink = styled('div')`
	position: absolute;
	top: 9px;
	left: 9px;
	z-index: 1;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 30px;
	height: 22px;
	border-radius: 6px;
	background-color: ${(props: IconLinkProps) => props.isYoutubeIcon ? StyleColor.White : StyleColor.Blue300};

	svg {
		width: ${(props: IconLinkProps) => props.isYoutubeIcon ? '30px' : '14px'};
		height: ${(props: IconLinkProps) => props.isYoutubeIcon ? '22px' : '14px'};
		fill: ${StyleColor.White};
	}
`;

const ButtonAdd = styled('button')`
	position: absolute;
	top: 9px;
	right: 39px;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 20px;
	height: 20px;
	padding: 0;
	border: 0;
	border-radius: 50%;
	background-color: ${StyleColor.Grey100};
	outline: 0;
	cursor: ${(props: ButtonProps) => props.disabled ? 'default' : 'pointer'};
	opacity: ${(props: ButtonProps) => props.disabled ? '0.5' : '1'};

	svg {
		width: 10px;
		height: 10px;
	}
`;

const Error = styled(Translate)`
	position: absolute;
	left: 0;
	bottom: 100%;
	font-family: HelveticaNeue, sans-serif;
	font-size: 14px;
	line-height: 20px;
	color: ${StyleColor.Red};
`;

export {
	Label,
	InputWrapper,
	IconLink,
	ButtonAdd,
	Error,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EditPanel/LinkPanel/styles.ts